export default "__VITE_ASSET__BLIpQMs$__"